export function initScrollable() {
  const items = document.getElementsByClassName("scrollable");

  Array.from(items).forEach((item) => {
    let isDown = false;
    let startX;
    let scrollLeft;

    item.addEventListener("mousedown", (e) => {
      isDown = true;
      item.classList.add("grabbing");
      startX = e.pageX - item.offsetLeft;
      scrollLeft = item.scrollLeft;
      // Only preventDefault when necessary
      // e.preventDefault();  // Often not needed here
    });

    item.addEventListener("mouseleave", () => {
      isDown = false;
      item.classList.remove("grabbing");
    });

    item.addEventListener("mouseup", () => {
      isDown = false;
      item.classList.remove("grabbing");
    });

    item.addEventListener("mousemove", (e) => {
      if (!isDown) return;

      e.preventDefault(); // Keep this one (important for drag)
      const x = e.pageX - item.offsetLeft;
      const walk = (x - startX) * 2;
      item.scrollLeft = scrollLeft - walk;
    });

    // === ADD TOUCH SUPPORT (very important) ===
    item.addEventListener(
      "touchstart",
      (e) => {
        isDown = true;
        item.classList.add("grabbing");
        startX = e.touches[0].pageX - item.offsetLeft;
        scrollLeft = item.scrollLeft;
      },
      { passive: true },
    ); // Important: passive for touch

    item.addEventListener("touchend", () => {
      isDown = false;
      item.classList.remove("grabbing");
    });

    item.addEventListener(
      "touchmove",
      (e) => {
        if (!isDown) return;
        const x = e.touches[0].pageX - item.offsetLeft;
        const walk = (x - startX) * 2;
        item.scrollLeft = scrollLeft - walk;
      },
      { passive: true },
    );
  });
}
